import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import MerchantDashboard from './merchant/MerchantDashboard';
import WaveDashboard from './wave/WaveDashboard';
import BankDashboard from './bank/BankDashboard';

const RoleDashboard: React.FC = () => {
  const role = useSelector((state: RootState) => state.auth.user?.role);

  if (role === 'merchant') return <MerchantDashboard />;
  if (role === 'wave') return <WaveDashboard />;
  return <BankDashboard />;
};

export default RoleDashboard;

